export const shadows = {
  drop1: '2px 2px 6px 2px rgb(52 51 62 / 8%);',
  drop2: '0.125rem 0.125rem 0.3125rem rgba(52, 63, 78, 0.2)',
  drop3: '0.1875rem 0.1875rem 0.625rem rgba(52, 63, 78, 0.2)',
  modalFooter: '0.0625rem -0.125rem 0.25rem rgba(0, 0, 0, 0.15);',
  redHover: '0 0.125rem 0.125rem rgba(183, 24, 51, 0.25)',
} as const;
